module.exports = __webpack_public_path__ + "static/media/vr.c13720ad.png";